import { CurrentUserSetEvent, Debouncer, DefaultPublisher, getCurrentUser, ICurrentUser } from '@samc/common';
import { ref, computed, onUnmounted } from 'vue';

/**
 * Using method meant to get a reactive version of the current user
 * 
 * @param timeout The time in milliseconds to wait before updating the user
 * @returns Will return the current user as a reactive object
 */
export const useUser = (timeout = 1000) => {
  const user = ref<ICurrentUser | null>(getCurrentUser());
  const username = computed<string>(() => (user.value as any)?.username ?? '');
  const debouncer = new Debouncer();

  const subscribeEventId = DefaultPublisher
    .subscribe<CurrentUserSetEvent>(CurrentUserSetEvent.eventName, async e => {
      try {
        await debouncer.wait(timeout);
        user.value = e.currentUser;
      } catch (err) {
        if (err === 'Promise debounced')
          return;
        throw err;
      }
    });

  onUnmounted(() => {
    DefaultPublisher.unsubscribe(CurrentUserSetEvent.eventName, subscribeEventId);
    user.value = null;
  });

  return { user, username };
};